// src/auth/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        // Muestra un spinner o un mensaje mientras se verifica la autenticación
        return <div>Cargando...</div>;
    }

    if (!isAuthenticated) {
        // Redirige al login, guardando la ruta original para volver después
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;
